<template>
  <div ref="jobdetail" class="detail-wrapper">
    <!-- <div class="detail-cover">
      <label v-if="ssrData.jobResult.miscellaneous.length" v-show="showLabel" :class="{'animated fadeIn': showLabel}" class="job-label">{{ ssrData.jobResult.miscellaneous[0] }}</label>
    </div> -->
    <JobDetail
      v-if="id"
      :id="id"
      :show-new-tab="false"
      :show-predict="true"
      :preview="false"
      :disabled="underPreview"
      :ssr-data="ssrData"
    />
</div>
</template>
<script>
import JobDetail from '../components/search/JobDetail'
// import commonFunc from '~/assets/js/commonHelper.js'
export default {
  components: {
    JobDetail
  },
  data: function () {
    return {
      id: null,
      seo: {},
      ssrData: {},
      showLabel: false,
      underPreview: false
    }
  },
  computed: {
    metaLdPJson () {
      const employmentType = {
        1: 'FULL_TIME',
        2: 'PART_TIME',
        3: 'OTHER',
        4: 'INTERN',
        5: 'CONTRACTOR',
        7: 'TEMPORARY'
      }
      const vm = this
      const datePostedObj = this.ssrData.jobResult.activationdate ? new Date(this.ssrData.jobResult.activationdate.timestamp * 1000) : null
      const validThroughObj = this.ssrData.jobResult.expirationdate ? new Date(this.ssrData.jobResult.expirationdate.timestamp * 1000) : null
      const addressLocality = this.ssrData.jobResult.locationdesc && Object.keys(this.ssrData.jobResult.locationdesc).length > 0 && Object.keys(this.ssrData.jobResult.locationdesc).map(function (key, index) { return vm.ssrData.jobResult.locationdesc[key].en }).join(', ')
      const addressRegion = this.ssrData.jobResult.citydesc && Object.keys(this.ssrData.jobResult.citydesc).length > 0 && Object.keys(this.ssrData.jobResult.citydesc).map(function (key, index) { return vm.ssrData.jobResult.citydesc[key].en }).join(', ')
      const addressCountry = this.ssrData.jobResult.countrydesc && Object.keys(this.ssrData.jobResult.countrydesc).length > 0 && Object.keys(this.ssrData.jobResult.countrydesc).map(function (key, index) { return vm.ssrData.jobResult.countrydesc[key].en }).join(', ')
      const jsonObj = {
        '@context': 'http://schema.org',
        '@type': 'JobPosting',
        datePosted: datePostedObj ? `${datePostedObj.getFullYear()}-${('0' + (datePostedObj.getMonth() + 1)).slice(-2)}-${('0' + datePostedObj.getDate()).slice(-2)}` : '-',
        description: `${this.ssrData.jobResult.description}`,
        hiringOrganization: {
          '@type': 'Organization',
          name: `${this.ssrData.jobResult.displayname}`,
          logo: `https://jobs.getlinks.com/static/logo/${this.logoName}`,
          description: `${this.ssrData.jobResult.companyintro}`
        },
        jobLocation: {
          '@type': 'Place',
          address: {
            '@type': 'PostalAddress',
            streetAddress: 'N/A',
            addressLocality,
            addressRegion,
            addressCountry,
            postalCode: '999077'
          }
        },
        title: `${this.ssrData.jobResult.jobtitletext}`,
        validThrough: validThroughObj ? `${validThroughObj.getFullYear()}-${('0' + (validThroughObj.getMonth() + 1)).slice(-2)}-${('0' + validThroughObj.getDate()).slice(-2)}` : '-',
        employmentType: employmentType[this.ssrData.jobResult.employmentstatus],
        baseSalary: {
          '@type': 'MonetaryAmount',
          currency: 'THB',
          value: {
            '@type': 'PropertyValue',
            value: 'N/A'
          }
        },
        identifier: {
          '@type': 'PropertyValue',
          name: 'jobs.getlinks.com',
          value: `${this.ssrData.jobResult.id}`
        }
      }
      if (jsonObj.employmentType === undefined) {
        jsonObj.employmentType = 'OTHER'
      }
      if (this.ssrData.jobResult.showsalary === null) {
        if (Number(this.ssrData.jobResult.minsalary) > 0 || Number(this.ssrData.jobResult.maxsalary) > 0) {
          delete jsonObj.baseSalary.value.value
          if (Number(this.ssrData.jobResult.minsalary) > 0) { jsonObj.baseSalary.value.minValue = Number(this.ssrData.jobResult.minsalary) }
          if (Number(this.ssrData.jobResult.maxsalary) > 0) { jsonObj.baseSalary.value.maxValue = Number(this.ssrData.jobResult.maxsalary) }
          jsonObj.baseSalary.value['@type'] = 'QuantitativeValue'
          jsonObj.baseSalary.value.unitText = 'MONTH'
        }
      }
      if (jsonObj.hiringOrganization.name === '') {
        jsonObj.hiringOrganization.name = 'Anonymous'
      }
      if (jsonObj.description === '') {
        jsonObj.description = 'N/A'
      }
      if (jsonObj.jobLocation.address.addressLocality === false || jsonObj.jobLocation.address.addressLocality === '') {
        jsonObj.jobLocation.address.addressLocality = 'N/A'
      }
      if (jsonObj.jobLocation.address.addressRegion === false || jsonObj.jobLocation.address.addressRegion === '') {
        jsonObj.jobLocation.address.addressRegion = 'N/A'
      }
      if (jsonObj.jobLocation.address.addressCountry === false || jsonObj.jobLocation.address.addressCountry === '' || jsonObj.jobLocation.address.addressCountry !== 'Hong Kong') {
        jsonObj.jobLocation.address.addressCountry = 'N/A'
      } else {
        jsonObj.jobLocation.address.addressCountry = 'HK'
      }
      return JSON.stringify(jsonObj, null, 2)
    }
  },
  async asyncData(ctx) {
    const { req, store, route } = ctx
    const urls = req.url.split('?')
    const url = urls[0]
    await store.dispatch('search/fetchSeo', url)
    const slug = route.params.id
    let preview = false
    const path = route.path
    if (path.indexOf('preview') !== -1) {
      preview = true
    }
    const id = slug.split('-')[slug.split('-').length - 1]
    const ssrData = {}
    await store.dispatch('jobs/fetchDetail', {
      id: id,
      customized: req.query.customized !== undefined ? req.query.customized : 0
    })
    await store.dispatch('jobs/fetchCompany', id)
    ssrData.jobResult = await store.state.jobs.detail
    // // redirect the new job with same job title
    // if (id !== ssrData.jobResult.id) {
    //   redirect('job/' + commonFunc.getSlug(ssrData.jobResult.jobtitletext) + '-' + ssrData.jobResult.id)
    // }
    ssrData.companyResult = await store.state.jobs.company
    ssrData.cdata = await store.state.jobs.companyOther
    return {
      seo: store.state.search.seo,
      ssrData: ssrData,
      underPreview: preview
    }
  },
  head() {
    return {
      title: this.seo.title,
      meta: [
        { hid: 'keywords', name: 'keywords', content: this.seo.metakeyword },
        { hid: 'description', name: 'description', content: this.seo.desc },
        { property: 'og:title', content: `${this.ssrData.jobResult.jobtitletext} Job Vacancies at ${this.ssrData.jobResult.displayname} | getlinks ` },
        { property: 'og:image', content: 'https://jobs.getlinks.com/images/shortcut_icon.png' },
        { property: 'og:site_name', content: 'getlinks.com' },
        { property: 'og:description', content: `${this.ssrData.jobResult.jobtitletext}  Check out this position, I think it may fit you.` }
      ],
      link: [
        { rel: 'amphtml', href: `${process.env.AMP_HOST}job/${this.ssrData.jobResult.id}` }
      ],
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        { innerHTML: this.metaLdPJson, type: 'application/ld+json' }
      ]
    }
  },
  mounted() {
    const event = new Event('isProfilePage')
    window.dispatchEvent(event)
    const vm = this
    const slug = this.$route.params.id
    if (slug) {
      this.id = slug.split('-')[slug.split('-').length - 1]
    }
    window.addEventListener('loadedJobdetail', function() {
      vm.showLabel = true
    })
    if (this.ssrData.jobResult.miscellaneous.length) {
      this.applyLabel()
    }
  },
  methods: {
    applyLabel: function() {
      const windowWidth = window.innerWidth
      if (this.$refs.jobdetail) {
        if (windowWidth <= 1023) {
          const jobLabel = document.querySelector('.job-label')
          document.querySelector('#search-box').appendChild(jobLabel)
        }
      }
    }
  }
}
</script>

<style lang="scss">
@media (max-width: 1023px){
  #cp-search-nav {
    height: 64px !important;
    border: none;
  }
}
</style>
